<template>
  <v-ons-page>
    <v-ons-toolbar class="home-toolbar">
      <div class="left">
        <v-ons-button modifier="quiet" style="margin: 6px 0" @click="goBack()">＜戻る</v-ons-button>
      </div>
      <div class="center" style="text-align: center;">{{ msg }}</div>
      <div class="right"></div>
    </v-ons-toolbar>

    <v-ons-list>
      <v-ons-list-title>登録済みメールアドレス</v-ons-list-title>
      <v-ons-list-item modifier="nodivider">
        <!-- <div class="left"><v-ons-icon fixed-width icon="fa-user"></v-ons-icon></div> -->
        <div class="left"><span style="font-size: 0.7em;">Email：　</span></div>
        <div class="center"><span style="font-size: 0.9em;">{{account.email}}</span></div>
      </v-ons-list-item>

      <!-- <v-ons-button modifier="outline" @click="doDeleteAll()" style="color: red;">削除テスト</v-ons-button> -->
    </v-ons-list>

    <v-ons-card>
      <div class="content">
        <div class="center">
          <v-ons-button modifier="outline" @click="clearCache()" style="color: blue;">キャッシュクリア</v-ons-button>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <span class="list-item__title">セーブ情報をクリアします。</span>
              <span class="list-item__subtitle" style="font-size: 0.8em;">サーバ上のデータは消えませんので<br>継続してご利用可能ですが<br>再度メールアドレスを入力して<br>サインインが必要となります。</span>
            </div>
          </v-ons-list-item>
        </div>
      </div>
    </v-ons-card>

    <v-ons-card>
      <div class="content">
        <div class="center">
          <v-ons-button modifier="outline" @click="DeleteDialogOn = true" style="color: red;">アカウントを削除</v-ons-button>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <span class="list-item__title">セーブ情報とサーバ上の情報を<br>すべて削除します。</span>
              <span class="list-item__subtitle" style="font-size: 0.8em;">本サービスのご利用を終了する際に<br>実行してください。</span>
            </div>
          </v-ons-list-item>
        </div>
      </div>
    </v-ons-card>

    <div id="firebaseui-auth-container"></div>

    <v-ons-alert-dialog modifier="rowfooter" :visible.sync="DeleteDialogOn">
      <span slot="title">アカウントを削除</span>
      これまでのデータが全て消えます。<br>
      本当に削除しますか？
      <template slot="footer">
        <v-ons-alert-dialog-button @click="DeleteDialogOn = false">キャンセル</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button @click="deleteCheck">削除する</v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

    <v-ons-dialog :visible.sync="confirmDialogOn">
      <div class="dialogview2">
        <v-ons-button class="closebutton" modifier="quiet" @click="confirmDialogOn = false"><v-ons-icon icon="fa-window-close"></v-ons-icon></v-ons-button>
        <v-ons-card>
          <div class="title">アカウント削除</div>
          <div class="content">
            <v-ons-list>
              <v-ons-list-item>
                <div class="center">
                  登録されているメールアドレス宛に確認用メールを送信しました。<br>
                  メール内のURLリンクを押してください。
                </div>
              </v-ons-list-item>
            </v-ons-list>
            <br>
            <!-- <v-ons-button @click="deleteAll()" modifier="large">アカウント削除を実行</v-ons-button> -->
          </div>
        </v-ons-card>
      </div>
    </v-ons-dialog>

    <v-ons-modal :visible="modalRedirectBackWaitOn">
      <!-- <div class="header">アカウント削除実行中．．．</div> -->
      <p style="text-align: center">
        アカウント削除実行中．．． <v-ons-icon icon="fa-spinner" spin></v-ons-icon>
      </p>
    </v-ons-modal>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
import common from '../../util/common'

export default {
  name: 'AccountEdit',
  mixins: [common],
  data () {
    return {
      msg: 'アカウント情報の編集',
      DeleteDialogOn: false,
      confirmDialogOn: false,
      modalRedirectBackWaitOn: false
      // delSequence: ''
      // delCount: 0
    }
  },

  created () {
    console.log('Created AccountEdit')
    // PC Chrome
    // GoogleなどのOAuthをリダイレクトで再認証したら、Createdは呼ばれずにMountedに帰ってくる。
  },

  mounted () {
    console.log('Mounted AccountEdit')
    // if (localStorage.getItem('OAuthRedirect') === 'yes') {
    //   this.redirectBackOAuth()
    // }
    const self = this
    let isContinue = localStorage.getItem('emailForSignIn')
    if ((isContinue !== null) && (isContinue !== undefined)) {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          self.account = user
          // User is signed in.
          self.deleteAll()
        } else {
          // No user is signed in.
          console.log('No user is signed in.')
        }
      })
    }
  },

  computed: {
  },

  watch: {
    // delCount: function () {
    //   console.log('delCount changed: ', this.delCount)
    //   if (this.delCount === 0) {
    //     if (this.delSequence === 'members') {
    //       this.delSequence = 'mobDone'
    //     } else if (this.delSequence === 'mobDone') {
    //       this.delSequence = 'profiles'
    //     } else if (this.delSequence === 'profiles') {
    //       this.delSequence = 'user'
    //     } else if (this.delSequence === 'user') {
    //       this.delSequence = 'account'
    //     }
    //   }
    // },
    // delSequence: function () {
    //   if (this.delSequence === 'mobDone') {
    //     this.deleteProfiles()
    //   } else if (this.delSequence === 'profiles') {
    //     this.deleteUser()
    //   } else if (this.delSequence === 'user') {
    //     // DefaultComponentへのリブートではストアの内容はクリアされないので念のためクリアしておく。
    //     this.profiles = []
    //     this.schools = []
    //     this.selectedSchool = 0
    //     this.school = {}
    //     this.selectedProfile = {}
    //     this.selectedMember = {}
    //     this.deleteAccount()
    //     this.clearCache()
    //   }
    // }
  },

  methods: {
    deleteCheck: function () {
      const email = firebase.auth().currentUser.email
      const linkId = this.timestamp()
      const actionCodeSettings = {
        url: window.location.href + '?linkId=' + linkId,
        // This must be true.
        handleCodeInApp: true
      }

      firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
        .then(function () {
          window.localStorage.setItem('emailForSignIn', email)
          window.localStorage.setItem('linkId', linkId)
          console.log('linkId', linkId)
        })
        .catch(function (error) {
          // Some error occurred, you can inspect the code: error.code
          console.log('sendSignInLinkToEmail Error: ', error)
        })

      this.DeleteDialogOn = false
      this.confirmDialogOn = true
    },

    deleteAll: function () {
      var self = this
      const account = firebase.auth().currentUser
      const email = localStorage.getItem('emailForSignIn')

      // Email系はこちらで再認証
      // credential = firebase.auth.EmailAuthProvider.credential(account.email, this.password)
      // console.log('window.location.href', window.location.href)
      const credential = firebase.auth.EmailAuthProvider.credentialWithLink(email, window.location.href)
      // ユーザが再認証状態にしておかないとクライアントからのユーザ削除がエラーで失敗する。
      this.modalRedirectBackWaitOn = true

      // console.log('reauthenticateWithCredential')
      account.reauthenticateWithCredential(credential)
        .then(function () {
          // User re-authenticated.
          console.log('アカウント認証が成功しました。')
          self.doDeleteAll()
          localStorage.clear()
          self.confirmDialogOn = false
          self.modalRedirectBackWaitOn = false
        }).catch(function (error) {
          // An error happened.
          console.log('email再認証エラー', error)
          self.$ons.notification.alert('アカウント認証に失敗しました。')
        })
      this.confirmDialogOn = false
      this.modalRedirectBackWaitOn = false
    },

    doDeleteAll: async function () {
      await this.deleteMessages()
      await this.deleteScheduledMessages()
      await this.deleteAuthInfo()
      await this.deleteUser()
      this.deleteAccount()
    },

    deleteAccount () {
      const self = this

      firebase.auth().currentUser.delete().then(function () {
        localStorage.clear()
        console.log('Account Deleted!')
        self.$ons.notification.alert('アカウント情報を削除しました。<br>ご利用ありがとうございました。')
        self.modalRedirectBackWaitOn = false
        self.$router.push({path: '/'})
      })
      .catch(function (error) {
        console.log('Account Delete Error', error)
        self.$ons.notification.alert('アカウント削除に失敗しました。')
        self.modalRedirectBackWaitOn = false
        self.$router.push({path: '/'})
      })
    },

    deleteUser: async function () {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.account.uid)

      console.log('deleteUser')
      return new Promise(async (resolve, reject) => {
        let promises = []
        promises[0] = userRef.get()
        .then((doc) => {
          let recv = []
          if (doc.exists) {
            // console.log('doc', doc.ref)
            recv.push(doc.ref)
            promises.push(self.deleteDocs(recv))
          }
          return recv.length
        })
        .catch((err) => {
          console.log('deleteUser error: ', err)
        })

        await Promise.all(promises)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
      })
    },

    deleteMessages: async function () {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.account.uid)
      const messagesRef = userRef.collection('messages')

      console.log('deleteMessages')
      return new Promise(async (resolve, reject) => {
        let promises = []
        promises[0] = messagesRef.get()
        .then((snapshot) => {
          let recv = []
          if (snapshot.size > 0) {
            for (let i = 0; i < snapshot.size; i++) {
              recv.push(snapshot.docs[i].ref)
              let docData = snapshot.docs[i].data()
              if (docData.attachments.length > 0) {
                self.deleteAllAttachments(docData)
              }
            }
            promises.push(self.deleteDocs(recv))
          }
          return recv
        })

        await Promise.all(promises)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
      })
    },

    deleteScheduledMessages: async function () {
      const self = this
      const scheduledRef = firebase.firestore().collection('/scheduled')
      const myScheduledRef = scheduledRef.where('userId', '==', this.account.uid)

      console.log('deleteScheduledMessages')
      return new Promise(async (resolve, reject) => {
        let promises = []
        promises[0] = myScheduledRef.get()
        .then((snapshot) => {
          let recv = []
          if (snapshot.size > 0) {
            for (let i = 0; i < snapshot.size; i++) {
              recv.push(snapshot.docs[i].ref)
              let docData = snapshot.docs[i].data()
              if (docData.attachments.length > 0) {
                self.deleteAllAttachments(docData)
              }
            }
            promises.push(self.deleteDocs(recv))
          }
          return recv
        })
        .catch((err) => {
          console.log('deleteScheduledMessages error: ', err)
        })

        await Promise.all(promises)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
      })
    },

    deleteAuthInfo: async function () {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.account.uid)
      const authRef = userRef.collection('auth')

      console.log('deleteAuthInfo')
      return new Promise(async (resolve, reject) => {
        let promises = []
        promises[0] = authRef.get()
        .then((snapshot) => {
          let recv = []
          if (snapshot.size > 0) {
            for (let i = 0; i < snapshot.size; i++) {
              recv.push(snapshot.docs[i].ref)
            }
            promises.push(self.deleteDocs(recv))
          }
          return recv
        })
        .catch((err) => {
          console.log('deleteAuthInfo error: ', err)
        })

        await Promise.all(promises)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
      })
    },

    deleteDocs: function (docRefs) {
      // const self = this
      const db = firebase.firestore()
      const batch = db.batch()

      if (docRefs) {
        if (docRefs.length > 0) {
          // console.log('deleteDocs')
          return new Promise((resolve, reject) => {
            for (let i = 0; i < docRefs.length; i++) {
              batch.delete(docRefs[i])
            }

            return batch.commit()
            .then(() => {
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
          })
        }
      }
    },

    deleteAllAttachments (doc) {
      const userId = this.account.uid
      const storageRef = firebase.storage().ref()

      for (let i = 0; i < doc.attachments.length; i++) {
        storageRef.child('attachment/' + userId + '/messages/' + doc.id + '/' + doc.attachments[i].name).delete()
          .then(function () {
            // File deleted successfully
            console.log('file deleted')
          }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log('file delete error', error)
          })
      }
      if (doc.movie !== '') {
        storageRef.child('attachment/' + userId + '/messages/' + doc.id + '/movie/' + doc.movie.name).delete()
          .then(function () {
            // File deleted successfully
            console.log('movie deleted')
          }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log('movie delete error', error)
          })
      }
    },

    clearCache: function () {
      localStorage.clear()
      this.$ons.notification.alert('キャッシュデータを<br>クリアしました。')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#addbutton {
  margin-top: 50px;
}

.dialogview2{
  width: 300px;
  height: 550px;
  max-height: 550px;
  overflow-y: auto;
}

.dialogview3{
  width: 300px;
  height: 300px;
  max-height: 300px;
  overflow-y: auto;
}

.header {
  text-align: center;
}

img {
  max-width: 300px;
}

ons-list-title {
  text-transform: none;
}

ons-list-title:not(:first-of-type) {
  margin-top: 30px;
}

ons-card {
  text-align: center;
}

ons-list-item, ons-card {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountChildren/AccountEdit.vue